import type { PrV2RepoFilePeek } from '@/lib/pr-v2/code-changes/types';
import { create } from 'zustand';

type PrV2RepoFileStore = {
  /** The file each pull request's side panel shows, keyed by `getPrV2ActiveFileStoreKey`. */
  openFileByPr: Record<string, PrV2RepoFilePeek>;
  openRepoFile: (prKey: string, peek: PrV2RepoFilePeek) => void;
  closeRepoFile: (prKey: string) => void;
};

/**
 * Which repository file the diff's side panel is reading, per pull request, so a file opened on
 * one pull request never shows on another. It has its own store, rather than a slot in the view
 * preferences, because nothing about an open panel should be persisted, and because the diff's
 * click handler and the panel both reach it.
 */
export const usePrV2RepoFileStore = create<PrV2RepoFileStore>((set) => ({
  openFileByPr: {},
  openRepoFile: (prKey, peek) =>
    set((state) => ({ openFileByPr: { ...state.openFileByPr, [prKey]: peek } })),
  closeRepoFile: (prKey) =>
    set((state) => {
      if (!(prKey in state.openFileByPr)) {
        return state;
      }

      const openFileByPr = { ...state.openFileByPr };
      delete openFileByPr[prKey];
      return { openFileByPr };
    }),
}));
